import React from 'react';
import { useLocation } from 'react-router-dom';
import styles from '../App.module.css';
import MonthlyFeatureList from '../components/FeatureLists/MonthlyFeatureList';
import AnnualFeatureList from '../components/FeatureLists/AnnualFeatureList';
import { API_BASE } from '../api/config';
import { useChat } from '../context/ChatContext';

const WelcomePage = ({ theme }) => {
  const location = useLocation();
  const userId = location.state?.user_id || null;
  const email = location.state?.user_email || null;
  const { user } = useChat();
  const firstName = user?.first_name || location.state?.first_name || 'Friend';  
  const accessLevel = location.state?.access_level || 'active';
  const monthlyPriceId = process.env.REACT_APP_STRIPE_MONTHLY_PRICE_ID;
  const annualPriceId = process.env.REACT_APP_STRIPE_ANNUAL_PRICE_ID;

  const handleCheckout = async (priceId) => {
    try {
      const user = JSON.parse(localStorage.getItem('daisy-user'));
      const token = user?.token;
      const email = user?.email;
      const userId = user?.id;

      const res = await fetch(`${API_BASE}/api/stripe/create-checkout-session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ email, priceId, userId }),
      });

      const data = await res.json();

      if (res.ok && data.url) {
        window.location.href = data.url;
      } else {
        alert('There was a problem launching the checkout. Please try again.');
      }
    } catch (err) {
      console.error('🚫 Error starting checkout:', err);
      alert('Something went wrong while trying to start checkout.');
    }
  };

  return (
    <div className={`${styles.container} ${theme === 'dark' ? styles.darkBackground : styles.lightBackground}`}>
      <div className={styles.staticContentBox}>
        <h1 className={styles.pageHeading}>🎉 Welcome, {firstName}!</h1>
        <p style={{ marginBottom: '1.5rem' }}>
          {accessLevel === 'expired' ? (
            <>
              Your <strong>14-day trial has expired</strong>.<br />
              We’d love for you to stay and keep growing with dAIsy.
            </>
          ) : (
            <>
              Your <strong>14-day trial</strong> has begun — let’s make it memorable.
            </>
          )}
        </p>

        <div style={{ border: '1px solid #ddd', padding: '1rem', marginBottom: '2rem', borderRadius: '8px' }}>
          <h3>💬 Monthly Plan – $9.99/month</h3>
          <MonthlyFeatureList />
          <button className={styles.primaryButton} onClick={() => handleCheckout(monthlyPriceId)}>
            Subscribe Monthly
          </button>
        </div>

        <div style={{ border: '1px solid #ddd', padding: '1rem', borderRadius: '8px' }}>
          <h3>🌻 Annual Plan – $99/year</h3>
          <AnnualFeatureList />
          <button className={styles.primaryButton} onClick={() => handleCheckout(annualPriceId)}>
            Subscribe Annually
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;
